import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { NbDialogService } from '@nebular/theme';
import { PAGE_CODE_MAP, TranslationService } from '../../language/translation.service';

@Component({
  selector: 'app-status-update-modal',
  templateUrl: './status-update-modal.component.html',
  styleUrls: ['./status-update-modal.component.scss'],
})
export class StatusUpdateModalComponent implements OnInit, OnDestroy {
  @Output() emitList = new EventEmitter();
  @Output() emitClose = new EventEmitter();
  @Input() info: {
    getURL: string;
    updateURL: string;
    eosNo: string;
    source: number;
    IsLoding?: boolean;
  };

  @ViewChild('Modal') Modal: TemplateRef<any>;

  private readonly translationPageCodes = PAGE_CODE_MAP.common;
  modalRef = null;
  translationReady = false;

  USR_AccountInfo_ID: string;
  USR_EmployeeInfo_ID: string;
  ORG_Company_ID: number;
  ORG_Store_ID: number;

  statusList: Status[] = [];
  statusHistory: StatusHistory[] = [];

  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private cookieService: CookieService,
    private translationService: TranslationService,
  ) {
    this.USR_AccountInfo_ID = this.cookieService.get('USR_AccountInfo_ID')
      ? 'USR_AccountInfo_ID_' + this.cookieService.get('USR_AccountInfo_ID')
      : this.cookieService.get('USR_POSEmployeeInfo_ID')
        ? 'USR_POSEmployeeInfo_ID' + this.cookieService.get('USR_POSEmployeeInfo_ID')
        : null;
    this.USR_EmployeeInfo_ID = this.cookieService.get('USR_EmployeeInfo_ID');
    this.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'), 10);
    const cookieSid = this.cookieService.get('ORG_Store_ID');
    this.ORG_Store_ID = cookieSid && cookieSid !== '' ? parseInt(cookieSid, 10) : null;
  }

  async ngOnInit(): Promise<void> {
    this.translationService.initLanguage();
    await this.translationService.loadTranslations(this.translationPageCodes);
    this.translationReady = true;
  }

  ngOnDestroy(): void {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  t(key: string, fallback: string): string {
    const value = this.translationService.getText(key);
    return value === key ? fallback : value;
  }

  async ngAfterViewInit(): Promise<void> {
    await this.onOpen(this.info);
  }

  async onOpen(data): Promise<void> {
    await this.get_EOS_Status_List(data);
    await this.getEOSStatusHistory();
    this.modalRef = this.dialogService.open(this.Modal, {});
    this.modalRef.onClose.subscribe(() => {
      this.emitClose.emit(true);
    });
  }


  //取得狀態清單
  get_EOS_Status_List(data): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(data.getURL + `EOSNo=${data.eosNo}`).subscribe({
        next: result => {
          this.statusList = (result.LIST || []).map(element => ({
            statusName: element.Name,
            ID: element.ID,
            CanClick: element.CanClick,
          }));
          resolve(this.statusList);
        },
        error: error => {
          console.error('There was an error!', error);
          reject(error);
        },
      });
    });
  }


  //更新狀態
  onStatusClick(ID: string) {
    const data = this.info
    this.http.post<any>(data.updateURL, {
      // USR_AccountInfo_ID: this.USR_AccountInfo_ID, //建立者,      
      EOSNo: data.eosNo,
      EOS_Status_ID: ID,
      LastUpdateBy: this.USR_AccountInfo_ID,
    }).subscribe({
      next: () => {
        alert(this.t('common_sync_success', '同步成功'));
        this.onClose();
      },
      error: error => {
        console.error('There was an error!', error);
      },
    });
  }
 //取得歷程紀錄
   getEOSStatusHistory(): Promise<any> {
    const data = this.info;
    return new Promise((resolve, reject) => {
      this.http.post<any>('api/EOS/OrderManage/WebGetEOSInfoRecord', {
        EOSNo: data.eosNo,
        Source: data.source,
        Page: 1,
        PerPage: 3,
      }).subscribe({
        next: result => {
          this.statusHistory = (result.LIST || []).map(element => ({
            statusName: element.StatusName,
            CreateDate: element.CreateDate,
            CreateBy: element.CreateBy,
          }));
          resolve(this.statusHistory);
        },
        error: error => {
          console.error('There was an error!', error);
          reject(error);
        },
      });
    });
  }

  onClose(): void {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  // 商品 明細
  @ViewChild('ShowDataMo_Tmp', { static: false }) ShowDataMo_Tmp;
  ShowDataMo = {
    EOSNo: null,
    source: null,
    isShow: false,
    onOpen: () => {
      const my = this.ShowDataMo;
      my.EOSNo = this.info.eosNo;
      my.source = this.info.source;
      my.isShow = true;
    },
    onClose(v) {
      this.isShow = false;
    },
  };
}

interface Status {
  statusName: string;
  CanClick: boolean;
  ID: number;
}

interface StatusHistory {
  statusName: string;
  CreateBy: string;
  CreateDate: string;
}
